module.exports = __webpack_public_path__ + "img/17.cabcd4dd.png";